import clsx from 'clsx'
import React, { useState, useEffect } from 'react'
import { Heading, Text, Loader } from '@afterpaytouch/core'

import { AssetLayout } from '.'
import styles from './styles.module.css'

export const CashAppServicingMessage: AssetLayout = ({ heroTitle, primaryTitle, secondaryTitle, loaderTitle }) => {
  const [showSecondCopy, setShowSecondCopy] = useState(false)
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    const fadeTimer = setTimeout(() => {
      setFadeOut(true)
    }, 3500)

    const timer = setTimeout(() => {
      setShowSecondCopy(true)
    }, 4000)

    return () => {
      clearTimeout(timer)
      clearTimeout(fadeTimer)
    }
  }, [])

  const contentStyle = clsx(styles.cashappMessageContent, fadeOut && styles.fadeOut, fadeOut && showSecondCopy && styles.fadeIn)

  return (
    <>
      <div className={styles.cashappMessageLoading}>
        <Loader />
      </div>
      <div className={styles.cashappMessageHeading}>
        <Heading size='XL'>{heroTitle}</Heading>
      </div>
      <div className={contentStyle} data-testid='dynamic-content'>
        {!showSecondCopy && (
          <Text size='S' color='Subtle'>
            {secondaryTitle}
          </Text>
        )}
        {showSecondCopy && (
          <Text size='S' color='Subtle'>
            {loaderTitle}
          </Text>
        )}
      </div>
      <div className={styles.cashappMessageFooter}>
        <Text size='S' bold>
          {primaryTitle}
        </Text>
      </div>
    </>
  )
}
